export default __webpack_public_path__ + "static/media/904.d7d59d03.gif";